import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon } from 'lucide-react';
import { useRestaurant } from '../context/RestaurantContext';
function formatHour(h: number) {
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = h > 12 ? h - 12 : h === 0 ? 12 : h;
  return `${hour12}:00 ${period}`;
}
export function ClosedHoursBanner() {
  const {
    restaurant
  } = useRestaurant();
  const openHour = restaurant?.open_hour ?? 0;
  const closeHour = restaurant?.close_hour ?? 24;
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    type: 'spring',
    damping: 20
  }} className="fixed bottom-0 left-0 right-0 z-50 max-w-md mx-auto px-3 pb-3" data-id="element-925">
      <div className="bg-surface border border-indigo-500/20 rounded-2xl p-4 shadow-2xl shadow-black/40" data-id="element-926">
        <div className="flex items-center gap-3" data-id="element-927">
          <div className="w-11 h-11 bg-indigo-500/10 rounded-full flex items-center justify-center flex-shrink-0 border border-indigo-500/20" data-id="element-928">
            <MoonIcon className="w-5 h-5 text-indigo-400" data-id="element-929" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-930">
            <p className="text-white text-sm font-semibold leading-tight" data-id="element-931">
              Fuera de horario
            </p>
            <p className="text-gray-500 text-xs mt-0.5" data-id="element-932">
              Pedidos de {formatHour(openHour)} a {formatHour(closeHour)}
            </p>
          </div>
        </div>
      </div>
    </motion.div>;
}